import axios from 'axios';
import { getStoredAuthToken } from '../config/auth';

const baseUrl = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, '') ?? '';
const apiPrefix = `${baseUrl}/api`;

const apiClient = axios.create({
  baseURL: apiPrefix,
  timeout: 15000,
  paramsSerializer: (params) => {
    const search = new URLSearchParams();

    Object.entries(params ?? {}).forEach(([key, value]) => {
      if (value === null || value === undefined) {
        return;
      }

      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item !== null && item !== undefined) {
            search.append(key, item);
          }
        });
        return;
      }

      search.append(key, value);
    });

    return search.toString();
  }
});

apiClient.interceptors.request.use((config) => {
  const token = getStoredAuthToken();

  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      window.dispatchEvent(new Event('auth:unauthorized'));
    }
    const message = error?.response?.data?.message || error.message;
    console.error('API request failed:', message, error);
    throw error;
  }
);

export default apiClient;
